export const DeleteFileModal: string = 'DeleteFileModal';
